// Desktop menu
$(document).ready(function (){
  $('.header__nav-list-item').on('mouseenter', function () {
   const megaMenuName = $(this).attr('data-mega-menu')
    $(`.header__nav-list-item-icon`).removeClass('active')
    $(`.header__nav-list-item-icon[data-mega-icon='${megaMenuName}']`).addClass('active')
    $(`div[data-mega-name]`).removeClass('active')
    $(`div[data-mega-name='${megaMenuName}']`).addClass('active')
  })
  $('.mega-menu').on('mouseleave', function () {
    $(`div[data-mega-name]`).removeClass('active')
    $(`.header__nav-list-item-icon`).removeClass('active')
  })
})
// End desktop menu


//   Mobile menu start
$(document).ready(function () {
  let activeMobileMenuLink = ''

  function openMobileMenu() {
    $('.mobile-menu').addClass('show')
    $(this).removeClass('show')
    $('.mobile-menu__icon-close').addClass('show')
    $('body').addClass('hidden-overflow')
  }

  function closeMobileMenu() {
    $('.mobile-menu').removeClass('show')
    $('.header__icons-item-button-open').addClass('show')
    $('.mobile-menu__icon-close').removeClass('show')
    $('body').removeClass('hidden-overflow')
  }

  function mainDropdownProcess() {
    let parentElement = $(this).parent()
    if (activeMobileMenuLink !== '' && $(this).attr('data-link-name') !== activeMobileMenuLink) {
      $(`ul[data-link-name='${activeMobileMenuLink}']`).removeClass('show')
      activeMobileMenuLink = $(this).attr('data-link-name')
    } else {
      activeMobileMenuLink = $(this).attr('data-link-name')
    }
    parentElement.children('ul').toggleClass('show')
  }

  $('.header__icons-item-button-open').on('click', openMobileMenu)
  $('.mobile-menu__icon-close').on('click', closeMobileMenu)
  $('.mobile-menu__list-item-button.main').on('click', mainDropdownProcess)
  $('.mobile-menu__list-item--title').on('click', mainDropdownProcess)
})
//   Mobile menu end

//   Footer start
$(document).ready(function () {
  if ($('.footer-menu-list__item-list').length > 0) {
    $('.footer-menu-list__item-link-box').on('click', function () {
      $(this).toggleClass('active');
      if ($(this).next().hasClass("active")) {
        $(this).next().slideUp(200, function () {
          $(this).toggleClass('active')
        });
      } else {
        $(this).next().slideDown(200, function () {
          $(this).toggleClass('active')
        });
      }
    })
  }
})
//   Footer end

// Collection js
const trapFocusHandlers = {};
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}
class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;
    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

function showMoreToggleProcess () {
  $('.toggleMore').on('click', function() {
    $(this).parents('.shortDescription').css('display', 'none')
    $(this).parents('.collection-description').find('.fullDescription').css('display', 'block')
  })
  $('.toggleLess').on('click', function() {
    $(this).parents('.fullDescription').css('display', 'none')
    $(this).parents('.collection-description').find('.shortDescription').css('display', 'block')
  })
}
showMoreToggleProcess()

$(document).on('filterGridUpdate', function () {
  showMoreToggleProcess()
})
function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}
// Collection js end

// site header search bar begin
$('.site-header__search-toggle').on( "click", function(e) {
  e.preventDefault();

  if ($(this).attr('aria-expanded') === 'false' ) {
    $(this).attr('aria-expanded', 'true')
    $('.site-header').addClass('headroom--not-top');
    $("#search-navbar").slideDown('fast').css('opacity','1');
    $(this).addClass('nav-visile');
    return
  }
  if ($(this).attr('aria-expanded') === 'true' ) {
    $(this).attr('aria-expanded', 'false')
    $('.site-header').removeClass('headroom--not-top');
    $("#search-navbar").slideUp('fast').css('opacity','0');
    $(this).removeClass('nav-visile');
    return
  }
});
// site header search bar end